<!-- Add New Campaign Dialog -->
<app-add-new-campaign-dialog
  [(visible)]="showAddNewCampaignDialog"
  (campaignCreated)="onCampaignCreated($event)">
</app-add-new-campaign-dialog>

<!-- Top section stays put; only the campaign table scrolls -->
<div class="dashboard-top" *ngIf="campaigns.length > 0">
  <!-- Top section: bordered collapsible area (hidden on phones) -->
  <div class="top-section-outer" *ngIf="!isSmallScreen">
    <div class="top-section-wrapper" [class.top-section-collapsed]="!topSectionVisible">
      <div class="top-section-inner">
        <!-- Top row: data points, chart, notifications -->
        <div class="top-widgets-row">
          <div class="info-boxes-column">
            <div class="info-box selectable" [class.info-box-active]="chartMetric === 'bookings'"
                 (click)="setChartMetric('bookings')" title="Show the Total Bookings chart">
              <div class="info-box-header">Gross Bookings</div>
              <div class="info-box-data">{{getFilteredRateTotal() | currency: 'USD':'symbol':'1.0-0'}}</div>
              <div class="info-box-footer">
                <div>
                  <span [class.green]="getGrossBookingsPctChange() >= 0" [class.red]="getGrossBookingsPctChange() < 0">{{getGrossBookingsPctChange() >= 0 ? '+' : ''}}{{getGrossBookingsPctChange() | number:'1.0-0'}}%</span>
                  <span [class.green]="getGrossBookingsDollarChange() >= 0" [class.red]="getGrossBookingsDollarChange() < 0">{{getGrossBookingsDollarChange() >= 0 ? '+' : '-'}}{{formatKDollars(getGrossBookingsDollarChange())}}</span>
                </div>
                <div class="info-box-footer-label">vs same mo. last yr</div>
              </div>
            </div>
            <div class="info-box selectable" [class.info-box-active]="chartMetric === 'count'"
                 (click)="setChartMetric('count')" title="Show the Campaign Count chart">
              <div class="info-box-header">Campaign Count</div>
              <div class="info-box-data">{{campaignsFiltered.length}}</div>
              <div class="info-box-footer">
                <div>
                  <span [class.green]="getActiveCampaignsPctChange() >= 0" [class.red]="getActiveCampaignsPctChange() < 0">{{getActiveCampaignsPctChange() >= 0 ? '+' : ''}}{{getActiveCampaignsPctChange() | number:'1.0-0'}}%</span>
                  <span [class.green]="getActiveCampaignsCountChange() >= 0" [class.red]="getActiveCampaignsCountChange() < 0">{{getActiveCampaignsCountChange() >= 0 ? '+' : ''}}{{getActiveCampaignsCountChange()}} campaigns</span>
                </div>
                <div class="info-box-footer-label">vs same mo. last yr</div>
              </div>
            </div>
            <div class="info-box">
              <div class="info-box-header">Rate/Booking This Month</div>
              <div class="info-box-data">{{getAvgRateCurrentMonth() | currency: 'USD':'symbol':'1.0-0'}}</div>
              <div class="info-box-footer">
                <span [class.green]="getAvgRatePctChange() >= 0" [class.red]="getAvgRatePctChange() < 0">{{getAvgRatePctChange() >= 0 ? '+' : ''}}{{getAvgRatePctChange() | number:'1.0-0'}}%</span>
                <span [class.green]="getAvgRateDollarChange() >= 0" [class.red]="getAvgRateDollarChange() < 0">{{getAvgRateDollarChange() >= 0 ? '+' : '-'}}{{formatKDollars(getAvgRateDollarChange())}} (last 3 mo)</span>
              </div>
            </div>
          </div>
          <div *ngIf="chartCampaigns.length > 0" class="widget-chart">
            <app-revenue-chart
              [campaigns]="chartCampaigns"
              [metric]="chartMetric"
              (monthSelected)="onChartMonthSelected($event)"
              (daySelected)="onChartDaySelected($event)"></app-revenue-chart>
          </div>
          <div class="widget-notifications">
            <app-notifications [filteredCampaigns]="chartCampaigns" [tasksVersion]="dueTasksVersion"></app-notifications>
          </div>
        </div>
      </div>
    </div>
    <!-- Toggle arrow — always visible, centered below the section -->
    <div class="top-section-toggle" (click)="toggleTopSection()" [title]="topSectionVisible ? 'Collapse' : 'Expand'">
      <span class="toggle-arrow" [class.arrow-up]="topSectionVisible" [class.arrow-down]="!topSectionVisible"></span>
    </div>
  </div>
</div>

<!-- Campaign table: filters + column headers pinned, rows scroll below -->
<div class="dashboard-scroll">
  <div class="sticky-header-block" *ngIf="campaigns.length > 0">
    <!-- Full-width campaigns header (filters + column headers) -->
    <div class="campaigns-section">
      <div class="top-row-container">
        <div>
          <button class="site-button" (click)="AddNewCampaign()">Add New Campaign</button>
        </div>
        <!-- Wide screens: inline toggles -->
        <ng-container *ngIf="!isSmallScreen">
          <div>
            <label for="show-completed-filter">Show Completed:</label>
            <input name='show-completed-filter' [(ngModel)]="showCompleted" (change)="updateFilteredCampaigns()" type="checkbox">
          </div>
          <div>
            <label for="show-deleted-filter">Show Deleted:</label>
            <input name='show-deleted-filter' [(ngModel)]="showDeleted" (change)="updateFilteredCampaigns()" type="checkbox">
          </div>
          <div *ngIf="selectedMonthKey">
            <span class="date-filter-chip">
              {{getDateSelectionLabel()}}
              <a href="javascript:void(0)" (click)="clearDateSelection()" title="Clear date filter">&times;</a>
            </span>
          </div>
          <div>
            <a href="javascript:void(0)" (click)="clearFilters()">Clear Filters</a>
          </div>
        </ng-container>

        <!-- Phones: the campaign search stays out, everything else goes in the drawer -->
        <ng-container *ngIf="isSmallScreen">
          <div class="mobile-search">
            <input class="campaign-name-filter" (input)="campaignNameFilterChange($event)" [(ngModel)]="campaignNameFilter" type="text" placeholder="Search campaigns">
          </div>
          <div>
            <button type="button" class="filters-toggle" [class.open]="mobileFiltersOpen" (click)="toggleMobileFilters()">
              Filters
              <span class="toggle-arrow" [class.arrow-up]="mobileFiltersOpen" [class.arrow-down]="!mobileFiltersOpen"></span>
            </button>
          </div>
        </ng-container>
      </div>

      <!-- Phone filters drawer -->
      <div class="mobile-filters" *ngIf="isSmallScreen && mobileFiltersOpen">
        <div class="mobile-filter-row">
          <label for="show-completed-filter-m">Show Completed</label>
          <input id="show-completed-filter-m" [(ngModel)]="showCompleted" (change)="updateFilteredCampaigns()" type="checkbox">
        </div>
        <div class="mobile-filter-row">
          <label for="show-deleted-filter-m">Show Deleted</label>
          <input id="show-deleted-filter-m" [(ngModel)]="showDeleted" (change)="updateFilteredCampaigns()" type="checkbox">
        </div>
        <div class="mobile-filter-field">
          <label>Source</label>
          <select [(ngModel)]="sourceFilter" (change)="sourceFilterChange($event)">
            <option value="All">All Sources</option>
            <option value="Dena">Dena</option>
            <option value="Amanda">Amanda</option>
            <option value="Inbound">Inbound</option>
            <option value="Outbound">Outbound</option>
          </select>
        </div>
        <div class="mobile-filter-field">
          <label>ID</label>
          <input class="campaign-name-filter" (input)="idFilterChange($event)" [(ngModel)]="idFilter" type="text" placeholder="Filter ID">
        </div>
        <div class="mobile-filter-field">
          <label>Brand/Agency</label>
          <input class="campaign-name-filter" (input)="brandFilterChange($event)" [(ngModel)]="brandFilter" type="text" placeholder="Filter Brand/Agency">
        </div>
        <div class="mobile-filter-field">
          <label>Creator</label>
          <input class="campaign-name-filter" (input)="creatorFilterChange($event)" [(ngModel)]="creatorFilter" type="text" placeholder="Filter Creator">
        </div>
        <div class="mobile-filter-field">
          <label>Agent</label>
          <select [(ngModel)]="agentFilter" (change)="agentFilterChange($event)">
            <option *ngFor="let agent of agents" [value]="agent">{{resolveUserId(agent)}}</option>
          </select>
        </div>
        <div class="mobile-filter-field">
          <label>Coordinator</label>
          <select [(ngModel)]="coordinatorFilter" (change)="coordinatorFilterChange($event)">
            <option *ngFor="let coordinator of coordinators" [value]="coordinator">{{resolveUserId(coordinator)}}</option>
          </select>
        </div>
        <div class="mobile-filter-row" *ngIf="selectedMonthKey">
          <span class="date-filter-chip">
            {{getDateSelectionLabel()}}
            <a href="javascript:void(0)" (click)="clearDateSelection()" title="Clear date filter">&times;</a>
          </span>
        </div>
        <div class="mobile-filter-row">
          <a href="javascript:void(0)" (click)="clearFilters()">Clear Filters</a>
        </div>
      </div>

      <div class="campaign-container" *ngIf="!isSmallScreen">
        <!-- Filters -->
        <div>
          <input class="campaign-name-filter" id='campaign-name-filter' name='campaign-name-filter'  (input)="campaignNameFilterChange($event)" [(ngModel)]="campaignNameFilter" type="text" placeholder="Filter Campaign Name">
        </div>
        <div class="source-filter-cell">
          <select [(ngModel)]="sourceFilter" (change)="sourceFilterChange($event)">
            <option value="All">All Sources</option>
            <option value="Dena">Dena</option>
            <option value="Amanda">Amanda</option>
            <option value="Inbound">Inbound</option>
            <option value="Outbound">Outbound</option>
          </select>
        </div>
        <div class="id-filter-cell">
          <input class="campaign-name-filter" (input)="idFilterChange($event)" [(ngModel)]="idFilter" type="text" placeholder="Filter ID">
        </div>
        <div></div>
        <div>
          <input class="campaign-name-filter" (input)="brandFilterChange($event)" [(ngModel)]="brandFilter" type="text" placeholder="Filter Brand/Agency">
        </div>
        <div>
          <input class="campaign-name-filter" (input)="creatorFilterChange($event)" [(ngModel)]="creatorFilter" type="text" placeholder="Filter Creator">
        </div>
        <div>
          <select [(ngModel)]="agentFilter" (change)="agentFilterChange($event)">
            <option *ngFor="let agent of agents" [value]="agent">{{resolveUserId(agent)}}</option>
          </select>
        </div>
        <div>
          <select [(ngModel)]="coordinatorFilter" (change)="coordinatorFilterChange($event)">
            <option *ngFor="let coordinator of coordinators" [value]="coordinator">{{resolveUserId(coordinator)}}</option>
          </select>
        </div>
        <div></div>

        <!-- Header Row -->
        <div class="campaign-header campaign-name">Campaign Name</div>
        <div class="campaign-header center">Status</div>
        <div class="campaign-header center">ID</div>
        <div class="campaign-header">Created</div>
        <div class="campaign-header">Brand/Agency</div>
        <div class="campaign-header">Creator</div>
        <div class="campaign-header center">Agent</div>
        <div class="campaign-header">Coordinator</div>
        <div class="campaign-header right">Rate</div>
      </div>
    </div>

  </div>

  <!-- Scrollable data rows -->
  <div *ngIf="campaigns.length > 0" class="campaigns-section">
    <div class="campaign-container" *ngIf="!isSmallScreen">
      <!-- Data Rows -->
      <ng-container *ngFor="let c of campaignsFiltered">
        <div class="cell" [class.deleted-row]="c.deleted" [class.completed-row]="c.complete"><a [routerLink]="['/agent/campaigns/', c.id]">{{c.name}}</a></div>
        <div class="cell center" [class.deleted-row]="c.deleted" [class.completed-row]="c.complete">
          <div class="status-container">
            <div class="status-circle" [ngClass]="'status-' + getCampaignStatus(c)"></div>
            <div class="status-text">{{getCampaignStatusTooltip(c)}}</div>
          </div>
        </div>
        <div class="cell center id" [class.deleted-row]="c.deleted" [class.completed-row]="c.complete">{{c.id.substring(0,8)}}</div>
        <div class="cell center" [class.deleted-row]="c.deleted" [class.completed-row]="c.complete">{{c.createdDate | date:'MM/dd/yy'}}</div>
        <div class="cell stacked-cell" [class.deleted-row]="c.deleted" [class.completed-row]="c.complete">
          <div>{{getBrandName(c.brandId)}}</div>
          <div class="cell-subtext">{{getAccountName(c.accountId)}}</div>
        </div>
        <div class="cell stacked-cell" [class.deleted-row]="c.deleted" [class.completed-row]="c.complete">
          <div>{{c.creatorName}}</div>
          <div class="cell-subtext">{{c.tiktokHandle}}</div>
        </div>
        <div class="cell centered" [class.deleted-row]="c.deleted" [class.completed-row]="c.complete">{{ resolveUserId(c.agentId).split(' ')[0] }}</div>
        <div class="cell centered" [class.deleted-row]="c.deleted" [class.completed-row]="c.complete">{{ resolveUserId(c.coordinatorId).split(' ')[0] }}</div>
        <div class="cell money right" [class.deleted-row]="c.deleted" [class.completed-row]="c.complete">{{ c.rate | currency: 'USD':'symbol':'1.2-2'}}</div>
      </ng-container>
    </div>

    <!-- Phones: one tile per campaign instead of a table row -->
    <div class="campaign-tiles" *ngIf="isSmallScreen">
      <a class="campaign-tile" *ngFor="let c of campaignsFiltered"
         [routerLink]="['/agent/campaigns/', c.id]"
         [class.deleted-tile]="c.deleted"
         [class.completed-tile]="c.complete">
        <div class="tile-title-row">
          <span class="status-circle" [ngClass]="'status-' + getCampaignStatus(c)"></span>
          <span class="tile-name">{{c.name}}</span>
          <span class="tile-rate">{{ c.rate | currency: 'USD':'symbol':'1.0-0'}}</span>
        </div>
        <div class="tile-detail">
          <span class="tile-label">Brand</span>
          <span class="tile-value">
            {{getBrandName(c.brandId)}}
            <span class="cell-subtext" *ngIf="getAccountName(c.accountId)">{{getAccountName(c.accountId)}}</span>
          </span>
        </div>
        <div class="tile-detail">
          <span class="tile-label">Creator</span>
          <span class="tile-value">
            {{c.creatorName}}
            <span class="cell-subtext" *ngIf="c.tiktokHandle">{{c.tiktokHandle}}</span>
          </span>
        </div>
        <div class="tile-status">{{getCampaignStatusTooltip(c)}}</div>
        <div class="tile-footer">
          <span class="tile-chip" *ngIf="c.agentId">{{ resolveUserId(c.agentId).split(' ')[0] }}</span>
          <span class="tile-chip" *ngIf="c.coordinatorId">{{ resolveUserId(c.coordinatorId).split(' ')[0] }}</span>
          <span class="tile-chip">{{c.createdDate | date:'MM/dd/yy'}}</span>
          <span class="tile-chip id">{{c.id.substring(0,8)}}</span>
        </div>
      </a>
    </div>

    <div class="error-message" *ngIf="errorMessage.length > 0">{{errorMessage}}</div>
  </div>
</div>

<div *ngIf="campaigns.length === 0" class="spinner-container">
  <div>Loading Campaigns...</div>
  <div><span class="loader"></span></div>
</div>
